module.exports = __webpack_public_path__ + "assets/img/fea693192013897c4072bddbf47712ce.svg";